<template>
  <div class="dot-dropper">
    <div
      class="dot-dropper__bg-wrapper"
      :style="{
        height: height * ratio + 'px',
        width: '100%',
        ['font-size']: ratio + 'em'
      }"
      @mousemove="updateActiveDotPosition($event)"
      @mouseup="onMouseUp()"
    >
      <img
        v-if="backgroundImage"
        class="dot-dropper__bg"
        :src="$store.state.assetsPath + backgroundImage"
        @click="clearStatusDot()"
      />
      <div v-else class="dot-dropper__bg-message">
        Please Choose a Masterplan Image
      </div>
      <div v-if="statusDot" class="dot-dropper__status">
        x:
        <input
          class="form-control"
          type="number"
          v-model.number="statusDot.x"
        />
        y:
        <input
          class="form-control"
          type="number"
          v-model.number="statusDot.y"
        />
      </div>

      <div
        v-for="element in elements"
        :key="element._id"
        @mousedown="onMouseDown(element)"
        @mouseup="onMouseUp()"
      >
        <tag-basic
          v-if="type === 'tag'"
          type="living-option"
          class="tag"
          colour="white"
          lang="en"
          tailPosition="none"
          :key="element._id"
          :label="{ en: element.label }"
          :pos="{ x: element.marker.x, y: element.marker.y }"
          :style="{ 'font-size': 20 * ratio + 'px' }"
        />
        <div
          v-else
          class="dot-dropper__dot"
          :style="{
            left: element.marker.x * ratio + 'px',
            top: element.marker.y * ratio + 'px'
          }"
        >
          <div class="dot-dropper__dot-label">
            <div>{{ element.label }}</div>
            <div class="text-black-50">
              x: {{ element.marker.x.toFixed(0) }} y:
              {{ element.marker.y.toFixed(0) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TagBasic from "@/components/TagBasic";
import { throttle } from "lodash";
export default {
  props: ["element-ids", "width", "height", "backgroundImage", "type", "value"],

  components: { TagBasic },

  data() {
    return {
      activeDot: null,
      statusDot: null,
      ratio: null
    };
  },

  computed: {
    elements() {
      return this.value.filter(option => this.elementIds.includes(option._id));
    }
  },

  methods: {
    clearStatusDot() {
      this.statusDot = null;
    },

    updateRatio() {
      this.ratio = this.$el.offsetWidth / this.width;
    },

    updateActiveDotPosition(e) {
      if (this.activeDot) {
        this.activeDot.x = Math.round(
          this.activeDot.x + e.movementX / this.ratio
        );
        this.activeDot.y = Math.round(
          this.activeDot.y + e.movementY / this.ratio
        );
        // this.activeDot.x += parseInt((e.movementX / this.ratio).toFixed(0))
        // this.activeDot.y += parseInt((e.movementY / this.ratio).toFixed(0))
      }
    },

    onMouseDown(element) {
      this.activeDot = element.marker;
      this.statusDot = element.marker;
    },

    onMouseUp() {
      this.activeDot = null;
      this.$emit("input", this.value);
    }
  },

  mounted() {
    window.addEventListener(
      "resize",
      throttle(e => {
        this.updateRatio();
      }, 100)
    );
    this.updateRatio();
  }
};
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.dot-dropper {
  max-width: 3040px;

  &__bg-wrapper {
    border: 1px solid #d4d4d4;
    position: relative;
    user-select: none;
  }

  &__bg {
    // pointer-events: none;
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &__bg-message {
    background-color: #eee;
    display: grid;
    font-size: 14px;
    height: 100%;
    place-items: center;
  }

  &__status {
    background-color: rgba($white, 0.7);
    color: $black;
    font-size: 16px;
    padding: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    input.form-control {
      display: inline-block;
      padding: 0 5px;
      width: 60px;
    }
  }

  &__dot {
    border-radius: 50%;
    background-color: red;
    cursor: pointer;
    position: absolute;
    height: 3em;
    width: 3em;
    user-select: none;
    opacity: 1;
    transform: translate(-0.25em, -0.4em);

    &::before {
      position: absolute;
      // content: "";
      left: 50%;
      top: 0;
      background-color: #fff;
      height: 100%;
      width: 0.2em;
    }

    &::after {
      position: absolute;
      // content: "";
      left: 0;
      top: 50%;
      background-color: #fff;
      height: 0.2em;
      width: 100%;
    }

    &:hover {
      .dot-dropper__dot-label {
        opacity: 1;
      }
    }
  }

  &__tag {
    // border-radius: 50%;
    // background-color: red;
    color: $white;
    cursor: pointer;
    position: absolute;
    // height: 3em;
    // width: 3em;
    user-select: none;
    opacity: 1;

    font-size: 1em;

    &::before {
      position: absolute;
      // content: "";
      left: 50%;
      top: 0;
      background-color: #fff;
      height: 100%;
      width: 0.2em;
    }

    &::after {
      position: absolute;
      // content: "";
      left: 0;
      top: 50%;
      background-color: #fff;
      height: 0.2em;
      width: 100%;
    }

    &:hover {
      .dot-dropper__dot-label {
        opacity: 1;
      }
    }
  }

  &__dot-label {
    bottom: calc(100% + 10px);
    background-color: white;
    border-radius: 3px;
    border-bottom-left-radius: 0;
    font-size: 12px;
    opacity: 0;
    padding: 5px 10px;
    pointer-events: none;
    position: absolute;
    text-align: center;
    white-space: nowrap;
    z-index: 999;

    &:after {
      content: "";
      left: 0;
      position: absolute;
      top: 100%;
      border: 5px solid white;
      border-color: white transparent transparent;
    }
  }
}
</style>
